export const first = [
    {
      name:"L'Equipe",
      path: "https://piano-piano.org/lassociation/lequipe"
    },
    {
      name:"Les projets",
      path: "https://piano-piano.org/les-projets-de-lassociation"
    },
    {
      name:"Nos partenaires",
      path: "https://piano-piano.org/les-partenaires"
    },
    {
      name:"Soutenir",
      path: "https://piano-piano.org/soutenir"
    }
  ];
  
  export const second = [
    {
      name:"Stage Piano Piano",
      path: "https://piano-piano.org/stage-piano-piano/"
    },
    {
      name:"L’académie Piano-Piano",
      path: "https://piano-piano.org/lacademie-piano-piano/"
    }
  ];
  
  export const third = [
    {
      name:"Les grands duos",
      path: "https://piano-piano.org/les-grands-duos/"
    },
    {
      name:"Dans le monde",
      path: "https://piano-piano.org/dans-le-monde/"
    },
    {
      name:"Un peu d’histoire",
      path: "https://piano-piano.org/un-peu-dhistoire/"
    }
  ];

